module.exports = __webpack_public_path__ + "static/media/lianxiyouxiang.0a6ced4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/lianxiyouxiang.svg
// module id = 637
// module chunks = 0